import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './reset-password.component'

let module = angular.module('resetPassword', [
  uiRouter
])
.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('resetPassword', {
      url: '/reset_password',
      component: 'resetPassword',
      myRenaultForbidden: true,
      authenticatedForbidden: true
    })
})
.component('resetPassword', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/reset-password/index.js